// 🔹 IMPORT PRICE TAB
import { renderPriceTab, initPriceSaveHandler } from "./priceTab.js";

// ==========================================================
// HTML
// ==========================================================
export function adPage() {
  return `
<div class="max-w-4xl mx-auto p-6">

  <div class="flex gap-4 border-b mb-6">
    <button class="tab-btn pb-2 border-b-2 border-transparent hover:text-blue-600"
      data-tab="tab-basic">General</button>

    <button class="tab-btn pb-2 border-b-2 border-transparent hover:text-blue-600"
      data-tab="tab-location">Location</button>

    <button class="tab-btn pb-2 border-b-2 border-transparent hover:text-blue-600"
      data-tab="tab-services">Services</button>

    <button class="tab-btn pb-2 border-b-2 border-transparent hover:text-blue-600"
      data-tab="tab-prices">Prices</button>
  </div>

  <div class="bg-white shadow-lg rounded-xl p-6">

    <form id="companyForm" class="space-y-5">

      <!-- 🔹 TAB: General -->
      <div id="tab-basic" class="tab">
        <label>Name</label>
        <input name="name" class="w-full border p-2 rounded" required />

        <label>Company name</label>
        <input name="company" class="w-full border p-2 rounded" />

        <label>Email</label>
        <input name="email" class="w-full border p-2 rounded" readonly />

        <label>Phone</label>
        <input name="phone" class="w-full border p-2 rounded" />

        <label>Website</label>
        <input name="website" class="w-full border p-2 rounded" />

        <label>Description</label>
        <textarea name="description" class="w-full border p-2 rounded"></textarea>
      </div>

      <!-- 🔹 TAB: Location -->
      <div id="tab-location" class="tab hidden">
        <label>Address</label>
        <input name="address" class="w-full border p-2 rounded" />

        <label>Province</label>
        <input name="province" class="w-full border p-2 rounded" />

        <label>City</label>
        <input name="city" class="w-full border p-2 rounded" />
      </div>

      <!-- 🔹 TAB: Services -->
      <div id="tab-services" class="tab hidden">
        <label>Services</label>
        <textarea name="services" class="w-full border p-2 rounded"></textarea>

        <label>Software</label>
        <select name="software" multiple class="w-full border p-2 rounded">
          <option value="LIDER-CALENER (HULC)">LIDER-CALENER (HULC)</option>
          <option value="CYPETHERM HE Plus">CYPETHERM HE Plus</option>
          <option value="SG SAVE">SG SAVE</option>
          <option value="TeKton3D TK-CEEP">TeKton3D TK-CEEP</option>
          <option value="CE3X">CE3X</option>
          <option value="CE3">CE3</option>
          <option value="CERMA">CERMA</option>
        </select>
      </div>

      <!-- 🔹 TAB: PRICES (NEW MODEL) -->
      <div id="tab-prices" class="tab hidden">
        <div id="advisor-prices-container">
          <p class="text-gray-500">Loading prices…</p>
        </div>
      </div>

      <button type="submit"
        class="bg-blue-600 text-white px-4 py-2 rounded">
        Save general data
      </button>

    </form>

  </div>
</div>
`;
}

// ==========================================================
// CONFIG
// ==========================================================
const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost:4000/api"
    : "/api";

// ==========================================================
// INIT
// ==========================================================
export async function initadPage() {

  const tabs = document.querySelectorAll(".tab-btn");
  const panels = document.querySelectorAll(".tab");

  tabs.forEach(btn => {
    btn.addEventListener("click", async () => {
      tabs.forEach(b => b.classList.remove("border-blue-600", "text-blue-600"));
      btn.classList.add("border-blue-600", "text-blue-600");

      panels.forEach(p => p.classList.add("hidden"));
      const active = document.getElementById(btn.dataset.tab);
      active.classList.remove("hidden");

      // 🔹 LOAD PRICES
      if (btn.dataset.tab === "tab-prices") {
        await loadAdvisorPrices();
      }
    });
  });

  const form = document.getElementById("companyForm");

  // ============================
  // LOAD COMPANY DATA
  // ============================
  const companyRes = await fetch(`${API_BASE}/company/me`, {
    credentials: "include"
  });

  if (companyRes.ok) {
    const json = await companyRes.json();
    if (json.success && json.company) {
      const company = json.company;
      Object.keys(company).forEach(key => {
        const field = form.querySelector(`[name="${key}"]`);
        if (!field) return;

        if (key === "software" && Array.isArray(company[key])) {
          Array.from(field.options).forEach(opt =>
            opt.selected = company[key].includes(opt.value)
          );
        } else {
          field.value = company[key] ?? "";
        }
      });
    }
  }

  // ============================
  // SAVE COMPANY
  // ============================
  form.addEventListener("submit", async e => {
    e.preventDefault();

    const data = {};
    new FormData(form).forEach((v, k) => {
      if (k === "software") {
        if (!data[k]) data[k] = [];
        data[k].push(v);
      } else {
        data[k] = v;
      }
    });

    const res = await fetch(`${API_BASE}/company/me`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });

    if (res.ok) alert("✅ Datos guardados");
    else alert("❌ Error al guardar");
  });
}

// ==========================================================
// LOAD + SAVE PRICES
// ==========================================================
async function loadAdvisorPrices() {
  const container = document.getElementById("advisor-prices-container");
  container.innerHTML = `<p class="text-gray-500">Loading prices…</p>`;

  try {
    // 🔹 1. Fetch prices
    const pricesRes = await fetch(`${API_BASE}/advisor/prices`, {
      credentials: "include",
    });

    const prices = pricesRes.ok ? await pricesRes.json() : [];

    // 🔹 2. Fetch company for global delivery time
    let deliveryDays = 5;

    try {
      const companyRes = await fetch(`${API_BASE}/company/me`, {
        credentials: "include",
      });

      if (companyRes.ok) {
        const json = await companyRes.json();
        if (json.success && json.company?.LeverTijd) {
          deliveryDays = json.company.LeverTijd;
        }
      }
    } catch (_) {
      // fallback remains 5
    }

    // 🔹 3. Render price tab with global delivery time
    container.innerHTML = renderPriceTab(prices, deliveryDays);

    // 🔹 4. Init save handler
    const advisorId =
      prices[0]?.advisor_id || window.loggedInUserId;

    initPriceSaveHandler(advisorId);

  } catch (err) {
    console.error(err);
    container.innerHTML =
      `<p class="text-red-600">Error loading prices</p>`;
  }
}

